import { ViewportScroller, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { NavigationEnd, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { environment } from 'src/environments/environment';
import { FetchDataService } from './shared/services/fetch-data.service';
import { ComponentService } from './shared/services/ComponentService/component.service';

declare let fbq: Function;
declare let ttq: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent {
  language!: string;
  whatsApp: any = {
    path: '',
    link: '',
  };

  constructor(
    private router: Router,
    private translate: TranslateService,
    private viewportScroller: ViewportScroller,
    private titleService: Title,
    private fetchDataService: FetchDataService,
    private componentService: ComponentService,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.whatsApp.path = `/assets/${environment.projectName}/icons/whatsapp-logo.png`;
    this.titleService.setTitle(environment.projectName.replace('-', ' '));

    if (isPlatformBrowser(this.platformId)) {
      const link: HTMLLinkElement = document.querySelector(
        "link[rel*='icon']"
      ) as HTMLLinkElement;
      if (link) {
        link.href = `/assets/${environment.projectName}/media/header/logo.png`;
      }
    }

    this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.language = this.router.url.split('/')[1];
        this.translate.setDefaultLang(this.language);

        if (isPlatformBrowser(this.platformId)) {
          this.trackPageView(event.urlAfterRedirects);
        }
      }
    });

    this.fetchDataService.loadStyles().subscribe({
      next: (style: any) => { this.applyStyles(style); },
      error: (err) => { console.error('Error fetching styles:', err); },
    });

    this.fetchDataService.getSocialLinks().subscribe({
      next: (data: any) => {
        this.whatsApp.link = data.soicalMediaLinks.find(
          (item: any) => item.name === 'whatsapp'
        )?.link;
      },
      error: (err) => { console.error('Error fetching services:', err); },
    });
  }

  private trackPageView(url: string): void {

    if (typeof fbq !== 'undefined') {

      if (url.match(/\/[a-z]{2}\/payment$/)) {
        const productKey = sessionStorage.getItem('productKey') ?? '';
        const productName = this.getProductName(productKey);
        fbq('track', 'AddToCart', {
          content_ids: [productKey],
          content_name: productName,
          content_type: 'product',
        });
     

      } else if (url.includes('/profile/myCourses')) {
        fbq('track', 'Purchase');
   

      } else if (url.includes('/signup')) {
        fbq('trackCustom', 'SignUp');
      

      } else if (url.includes('/contact')) {
        fbq('trackCustom', 'Contact');
      

      } else {
        fbq('track', 'PageView');
      
      }

    } 

    if (typeof ttq !== 'undefined') {
      ttq.page();

      if (url.match(/\/[a-z]{2}\/payment$/)) {
        const productKey = sessionStorage.getItem('productKey') ?? '';
        const productName = this.getProductName(productKey);
        ttq.track('AddToCart', {
          content_id: productKey,
          content_name: productName,
          content_type: 'product',
        });
      

      } else if (url.includes('/profile/myCourses')) {
        ttq.track('Purchased');
       

      } else if (url.includes('/signup')) {
        ttq.track('SignUp');
     

      } else if (url.includes('/contact')) {
        ttq.track('Contact');
      
      }

    }
  }

  private getProductName(productKey: string): string {
    const productNames: { [key: string]: string } = {
      'grammar': 'كورس النحو',
      'dictation': 'كورس الاملاء',
      'grammar-dictation': 'كورس النحو والاملاء',
    };
    return productNames[productKey] ?? productKey;
  }

  applyStyles(selectedStyles: any) {
    if (isPlatformBrowser(this.platformId)) {
      Object.entries(selectedStyles).forEach(([key, value]) => {
        document.documentElement.style.setProperty(`--${key}`, value as string);
      });
    }
  }

  title = 'Al-Bershama';
}